'use strict';

var _slicedToArray = require("/home/lana/NOZ/admin/noz-admin-cliente/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var execa = require('execa');
var lcid = require('lcid');
var mem = require('mem');
var defaultOptions = {
  spawn: true
};
var defaultLocale = 'en_US';
function getEnvLocale() {
  var env = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : process.env;
  return env.LC_ALL || env.LC_MESSAGES || env.LANG || env.LANGUAGE;
}
function parseLocale(string) {
  var env = string.split('\n').reduce(function (env, def) {
    var _def$split = def.split('='),
      _def$split2 = _slicedToArray(_def$split, 2),
      key = _def$split2[0],
      value = _def$split2[1];
    env[key] = value.replace(/^"|"$/g, '');
    return env;
  }, {});
  return getEnvLocale(env);
}
function getLocale(string) {
  return string && string.replace(/[.:].*/, '');
}
function getLocales() {
  return execa.stdout('locale', ['-a']);
}
function getLocalesSync() {
  return execa.sync('locale', ['-a']).stdout;
}
function getSupportedLocale(locale) {
  var locales = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return locales.includes(locale) ? locale : defaultLocale;
}
function getAppleLocale() {
  return Promise.all([execa.stdout('defaults', ['read', '-globalDomain', 'AppleLocale']), getLocales()]).then(function (results) {
    return getSupportedLocale(results[0], results[1]);
  });
}
function getAppleLocaleSync() {
  return getSupportedLocale(execa.sync('defaults', ['read', '-globalDomain', 'AppleLocale']).stdout, getLocalesSync());
}
function getUnixLocale() {
  if (process.platform === 'darwin') {
    return getAppleLocale();
  }
  return execa.stdout('locale').then(function (stdout) {
    return getLocale(parseLocale(stdout));
  });
}
function getUnixLocaleSync() {
  if (process.platform === 'darwin') {
    return getAppleLocaleSync();
  }
  return getLocale(parseLocale(execa.sync('locale').stdout));
}
function getWinLocale() {
  return execa.stdout('wmic', ['os', 'get', 'locale']).then(function (stdout) {
    var lcidCode = parseInt(stdout.replace('Locale', ''), 16);
    return lcid.from(lcidCode);
  });
}
function getWinLocaleSync() {
  var _execa$sync = execa.sync('wmic', ['os', 'get', 'locale']),
    stdout = _execa$sync.stdout;
  var lcidCode = parseInt(stdout.replace('Locale', ''), 16);
  return lcid.from(lcidCode);
}
module.exports = mem(function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultOptions;
  var envLocale = getEnvLocale();
  var thenable;
  if (envLocale || options.spawn === false) {
    thenable = Promise.resolve(getLocale(envLocale));
  } else if (process.platform === 'win32') {
    thenable = getWinLocale();
  } else {
    thenable = getUnixLocale();
  }
  return thenable.then(function (locale) {
    return locale || defaultLocale;
  }).catch(function () {
    return defaultLocale;
  });
});
module.exports.sync = mem(function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultOptions;
  var envLocale = getEnvLocale();
  var res;
  if (envLocale || options.spawn === false) {
    res = getLocale(envLocale);
  } else {
    try {
      res = process.platform === 'win32' ? getWinLocaleSync() : getUnixLocaleSync();
    } catch (_) {}
  }
  return res || defaultLocale;
});